import { TableCell } from '@mui/material';
import { RaterCoverageListDetail } from './rater.coverage.list.detail';

export const EXPANDED_CELL_SX = {
  backgroundColor: '#F3F3F3',
};

export const EXPANDED_CELL_SUBCOVERAGE_SX = {
  backgroundColor: '#eeeeee',
};

interface IRaterCoverageListDetailExpandedCellsProps {
  included?: boolean | null;
  limitRetentionFactor?: null | number;
  priorActsFactor?: null | number;
  waitingPeriodFactor?: null | number;
  restorationPeriodFactor?: null | number;
  policyTermFactor?: null | number;
  sharedPolicyAggregateFactor?: null | number;
  commissionAdjustmentFactor?: null | number;
  sharedCoverageAggregateFactor?: null | number;
  subCoverageFactor?: null | number;
  enhancedMediaFactor?: null | number;
  isRequestingRatingUpdate?: boolean;
  isSubCoverage?: boolean;
}

export const RaterCoverageListDetailExpandedCells = ({
  included,
  limitRetentionFactor,
  priorActsFactor,
  waitingPeriodFactor,
  restorationPeriodFactor,
  policyTermFactor,
  sharedPolicyAggregateFactor,
  commissionAdjustmentFactor,
  sharedCoverageAggregateFactor,
  subCoverageFactor,
  enhancedMediaFactor,
  isRequestingRatingUpdate,
  isSubCoverage,
}: IRaterCoverageListDetailExpandedCellsProps) => {
  const cellStyles = isSubCoverage
    ? EXPANDED_CELL_SUBCOVERAGE_SX
    : EXPANDED_CELL_SX;
  return (
    <>
      <TableCell aria-label="Limit retention factor" sx={cellStyles}>
        <RaterCoverageListDetail.Value
          isDisabled={!included || isRequestingRatingUpdate}
        >
          {limitRetentionFactor?.toFixed(3)}
        </RaterCoverageListDetail.Value>
      </TableCell>
      <TableCell aria-label="Prior acts factor" sx={cellStyles}>
        <RaterCoverageListDetail.Value
          isDisabled={!included || isRequestingRatingUpdate}
        >
          {priorActsFactor?.toFixed(3)}
        </RaterCoverageListDetail.Value>
      </TableCell>
      <TableCell aria-label="Waiting period factor" sx={cellStyles}>
        <RaterCoverageListDetail.Value
          isDisabled={!included || isRequestingRatingUpdate}
        >
          {waitingPeriodFactor?.toFixed(3)}
        </RaterCoverageListDetail.Value>
      </TableCell>
      <TableCell aria-label="Restoration period factor" sx={cellStyles}>
        <RaterCoverageListDetail.Value
          isDisabled={!included || isRequestingRatingUpdate}
        >
          {restorationPeriodFactor?.toFixed(3)}
        </RaterCoverageListDetail.Value>
      </TableCell>
      <TableCell aria-label="Enhanced media factor" sx={cellStyles}>
        <RaterCoverageListDetail.Value
          isDisabled={!included || isRequestingRatingUpdate}
        >
          {enhancedMediaFactor?.toFixed(3)}
        </RaterCoverageListDetail.Value>
      </TableCell>
      <TableCell aria-label="Subcoverage factor" sx={cellStyles}>
        <RaterCoverageListDetail.Value
          isDisabled={!included || isRequestingRatingUpdate}
        >
          {subCoverageFactor?.toFixed(3)}
        </RaterCoverageListDetail.Value>
      </TableCell>
      <TableCell aria-label="Shared coverage aggregate factor" sx={cellStyles}>
        <RaterCoverageListDetail.Value
          isDisabled={!included || isRequestingRatingUpdate}
        >
          {sharedCoverageAggregateFactor?.toFixed(3)}
        </RaterCoverageListDetail.Value>
      </TableCell>
      <TableCell aria-label="Policy term factor" sx={cellStyles}>
        <RaterCoverageListDetail.Value
          isDisabled={!included || isRequestingRatingUpdate}
        >
          {policyTermFactor?.toFixed(3)}
        </RaterCoverageListDetail.Value>
      </TableCell>
      <TableCell aria-label="Commission adjustment factor" sx={cellStyles}>
        <RaterCoverageListDetail.Value
          isDisabled={!included || isRequestingRatingUpdate}
        >
          {commissionAdjustmentFactor?.toFixed(3)}
        </RaterCoverageListDetail.Value>
      </TableCell>
      <TableCell aria-label="Shared aggregate factor" sx={cellStyles}>
        <RaterCoverageListDetail.Value
          isDisabled={!included || isRequestingRatingUpdate}
        >
          {sharedPolicyAggregateFactor?.toFixed(3)}
        </RaterCoverageListDetail.Value>
      </TableCell>
    </>
  );
};
